import size5x5 from './5x5.png';
import size5x10 from './5x10.png';
import size5x15 from './5x15.png';
import size10x10 from './10x10.png';
import size10x15 from './10x15.png';
import size10x20 from './10x20.png';
import size10x25 from './10x25.png';
import size10x30 from './10x30.png';

export default {
  '5x5': size5x5,
  '5x10': size5x10,
  '5x15': size5x15,
  '10x10': size10x10,
  '10x15': size10x15,
  '10x20': size10x20,
  '10x25': size10x25,
  '10x30': size10x30,
};
